<span (click)="sendCallback()" class="cur-pointer callback-button" *ngIf="!callbackLoading">
  <app-icon [size]="'18'" [glyph]="'callback'" [color]="'green-dark'" [class]="'icon--va-bottom'"></app-icon>
</span>
<span *ngIf="callbackLoading" class="callback-button">
  <app-icon [size]="'18'" [glyph]="'callback'" [color]="'black'" [class]="'icon--va-bottom'"></app-icon>
</span>
